<mat-expansion-panel class="mb-3" [expanded]="false" *ngIf="(beginning_items?.length ?? 0) > 0">
    <mat-expansion-panel-header class="parent-header">
        <mat-panel-title>
            Beginning Balance
        </mat-panel-title>
        <mat-panel-description>
            <span>{{ beginning_total | currency }}</span>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <app-invoice-items-accordion [items]="beginning_items"></app-invoice-items-accordion>
</mat-expansion-panel>

<mat-expansion-panel class="mb-3" [expanded]="true">
    <mat-expansion-panel-header class="parent-header">
        <mat-panel-title>
            Current Utility Charges
        </mat-panel-title>
        <mat-panel-description>
            <span>{{ utility_total | currency }}</span>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <app-invoice-items-accordion [items]="utility_items"></app-invoice-items-accordion>
</mat-expansion-panel>

<mat-expansion-panel class="mb-3" [expanded]="default_customer_array.length>0">
    <mat-expansion-panel-header class="parent-header">
        <mat-panel-title>
            Current Fees & Taxes
        </mat-panel-title>
        
        <mat-panel-description>
            {{ fee_total | currency }}
        </mat-panel-description>
    </mat-expansion-panel-header>

    <br>
    <div *ngIf="invoice_model.invoice_notice_message" class="alert alert-warning mb-3">
        <div style="float: left;">
            <fa-icon [icon]="faExclamationCircle"></fa-icon>
        </div>
        <div style="text-align:center;">
            {{ invoice_model.invoice_notice_message }}
        </div>  
    </div>

    <app-invoice-items-accordion [items]="fee_items"></app-invoice-items-accordion>

</mat-expansion-panel>

<mat-expansion-panel class="mb-3" [expanded]="false" *ngIf="(payment_items?.length ?? 0) > 0">
    <mat-expansion-panel-header class="parent-header">
        <mat-panel-title>
            Payment Activity
        </mat-panel-title>
        
        <mat-panel-description>
            {{ payment_total | currency }}
        </mat-panel-description>
    </mat-expansion-panel-header>

    <app-invoice-items-accordion [items]="payment_items"></app-invoice-items-accordion>

</mat-expansion-panel>

<mat-expansion-panel class="mb-3" [expanded]="true" *ngIf="(default_items?.length ?? 0) > 0">
    <mat-expansion-panel-header class="parent-header">
        <mat-panel-title>
            Default Charges & Fees
        </mat-panel-title>
        
        <mat-panel-description>
            {{ default_total | currency }}
        </mat-panel-description>
    </mat-expansion-panel-header>

    <app-invoice-items-accordion [items]="default_items"></app-invoice-items-accordion>

</mat-expansion-panel>

<mat-expansion-panel class="mb-3" [expanded]="false" *ngIf="(additional_items?.length ?? 0) > 0">
    <mat-expansion-panel-header class="parent-header">
        <mat-panel-title>
            Additional Adjustments
        </mat-panel-title>
        
        <mat-panel-description>
            {{ additional_total | currency }}
        </mat-panel-description>
    </mat-expansion-panel-header>

    <app-invoice-items-accordion [items]="additional_items"></app-invoice-items-accordion>

</mat-expansion-panel>